import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function IsForYouSection() {
  const isForYou = ['Tu hijo se enferma más de 4 veces por año', 'Tiene mocos crónicos o alergias constantes', 'Recibió más de 2 ciclos de antibióticos en el último año', 'Sufre de estreñimiento, gases o digestión irregular', 'Querés entender la raíz, no solo apagar el síntoma', 'Sos mamá consciente que lee etiquetas y busca alternativas', 'Estás dispuesta a cambiar hábitos de forma progresiva', 'Querés tener un sistema — no solo recetas sueltas'];
  const notForYou = ['Buscás un reemplazo total al médico', 'Querés resultados en 24 horas sin ningún cambio', 'No estás dispuesta a modificar ningún hábito alimentario', 'Esperás una solución mágica sin sistema ni constancia'];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-142">
      <div className="max-w-5xl mx-auto" data-id="element-143">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-144">
          {/* IS FOR YOU */}
          <FadeIn data-id="element-145">
            <div className="bg-green-mint/10 p-6 md:p-8 rounded-3xl border border-green-mint/30 h-full" data-id="element-146">
              <h3 className="font-heading font-bold text-xl md:text-2xl text-green-deep mb-6 flex items-center gap-2" data-id="element-147">
                <span className="text-2xl" data-id="element-148">✅</span> ESTE PROTOCOLO ES PARA VOS
                SI...
              </h3>
              <ul className="space-y-4" data-id="element-149">
                {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-150">
                    <CheckCircle2 className="w-5 h-5 text-green-lime shrink-0 mt-0.5" data-id="element-151" />
                    <span className="text-text-main/80 text-sm md:text-base" data-id="element-152">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NOT FOR YOU */}
          <FadeIn delay={0.2} data-id="element-153">
            <div className="bg-red-alert/5 p-6 md:p-8 rounded-3xl border border-red-alert/10 h-full" data-id="element-154">
              <h3 className="font-heading font-bold text-xl md:text-2xl text-text-main mb-6 flex items-center gap-2" data-id="element-155">
                <span className="text-2xl" data-id="element-156">❌</span> NO ES PARA VOS SI...
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-157">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-158">
                    <XCircle className="w-5 h-5 text-red-alert shrink-0 mt-0.5" data-id="element-159" />
                    <span className="text-text-main/80 text-sm md:text-base" data-id="element-160">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-auto pt-6 border-t border-red-alert/10" data-id="element-161">
                <p className="text-sm md:text-base text-text-main/80 italic" data-id="element-162">
                  Este protocolo <strong data-id="element-163">requiere compromiso.</strong> Los
                  resultados son reales, medibles — y duraderos.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}